"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pills = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = require("b2b-components/theme/components/Button");
var _classnames = _interopRequireDefault(require("classnames"));
require("./Pills.scss");
const Pills = _ref => {
  let {
    className,
    data,
    active,
    setActive
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-Pills', className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: rootClassName
  }, data.map(d => /*#__PURE__*/_react.default.createElement(_Button.Button, {
    key: d.value,
    className: "cds-Pills-Button",
    size: _Button.BUTTON_SIZE.small,
    styleType: d.value === active ? _Button.BUTTON_STYLE_TYPE.primary : _Button.BUTTON_STYLE_TYPE.light,
    onClick: () => setActive(d.value)
  }, d.label)));
};
exports.Pills = Pills;
//# sourceMappingURL=Pills.js.map